import { h } from "preact";
import { forwardRef } from "preact/compat";
import { useState } from "preact/hooks";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Box, DialogContent, DialogTitle } from "@material-ui/core";
import { QAppBar } from "../QAppBar";
const margin = "2rem";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: 0,
    margin: margin,
  },
}));

const Transition = forwardRef((props, ref, height) => (
  <Slide direction="up" ref={ref} {...props} />
));

export function BetterImage({ src, alt, height, center }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  let align = "center";

  switch (this.props.align) {
    case "left":
      align = "flex-start";
      break;
    case "right":
      align = "flex-end";
      break;
  }

  function openDialog(e) {
    setOpen(true);
  }

  const closeDialog = (e) => {
    setOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          maxWidth: "100%",
          height: height || "63dvh",
        }}
        onClick={openDialog}
      >
        {src}
      </Box>
      <Dialog
        id="betterImageDialog"
        fullScreen
        open={open}
        onClose={closeDialog}
        TransitionComponent={Transition}
      >
        <QAppBar text={alt} closeHandler={closeDialog} />
        <DialogContent className={classes.dialogContent}>
          <TransformWrapper>
            <TransformComponent>
              <Box
                width={`calc(100dvw - 4rem)`}
                height={`calc(100dvh - 90px - 4rem)`}
                display={center && "flex"}
                justifyContent={center && "center"}
                alignItems={center && "center"}
              >
                {src}
              </Box>
            </TransformComponent>
          </TransformWrapper>
        </DialogContent>
      </Dialog>
    </>
  );
}
